// assets/src/jsx/components/Home/Home.jsx
import React from 'react';
import {connect} from 'react-redux';
import Hero from 'components/Home/Hero';
import RecentDatabases from 'components/Home/RecentDatabases';
import FeatureHighlights from 'components/Home/FeatureHighlights';
import {getRecentDatabases} from 'appUtil/HomeUtils';

const hasAnyDatabase = (databaseList) => (
    Array.isArray(databaseList) && databaseList.some((c) =>
        (c.databases || []).some((d) => !d.is_archived)
    )
);

const Home = ({databaseList, eventBus}) => {
    // The app mutates `database.list` in place and signals refreshes via the
    // database EventBus (e.g. after an import), so re-render on `changed`.
    const [, forceTick] = React.useReducer((x) => x + 1, 0);
    React.useEffect(() => {
        if (!eventBus) {
            return undefined;
        }
        const handler = () => forceTick();
        eventBus.addListener('changed', handler);
        return () => eventBus.removeListener('changed', handler);
    }, [eventBus]);
    const populated = hasAnyDatabase(databaseList);
    return (
        <div className="app-wrapper gdb-home">
            {populated ? (
                <React.Fragment>
                    <Hero titleId="home.welcomeBack.title" subtitleId="home.welcomeBack.subtitle"/>
                    <RecentDatabases databases={getRecentDatabases(databaseList, 5)}/>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Hero titleId="home.welcome.title" subtitleId="home.welcome.subtitle"/>
                    <FeatureHighlights/>
                </React.Fragment>
            )}
        </div>
    );
};

const mapStateToProps = ({database}) => ({databaseList: database.list, eventBus: database.eventBus});

export default connect(mapStateToProps)(Home);
